module.exports = function () {
    $(document).ready(function () {

        console.log('working shit');
//.on('change', '.js-datepicker', function (e) {


        $('body').on('change', ".include-other", (function() {

            console.log($(this).val());
            if($(this).val() == 'other'){
               // $(this).next().removeClass('hidden');
                $('.'+$(this).attr('name')+'_textarea').removeClass('hidden').attr("disabled", false);
                $('.'+$(this).attr('name')+'_textarea').attr('name', $(this).attr('name'));
                if($('.'+$(this).attr('name')+'_textarea').val() == '0' ){
                    $('.'+$(this).attr('name')+'_textarea').empty();
                }
            }else{
                $('.'+$(this).attr('name')+'_textarea').addClass('hidden').attr("disabled", true).removeAttr('name');;

            }
            //$(this).change(function () { .attr('name')
            //    if ($('input[name="dateFrom"', $form ).val() != '' && $('input[name="dateTo"', $form).val() != '') {
            //        $('#'+report+'-pdf, #'+report+'-csv').removeAttr('disabled');
            //    }
            //})


            return false;
        }));

        $(".include-other").each(function(){
            if(!$('.'+$(this).attr('name')+'_textarea').val() || $('.'+$(this).attr('name')+'_textarea').val() == '0'){
                $('.'+$(this).attr('name')+'_textarea').addClass('hidden').attr("disabled", true).removeAttr('name');
                
            }else{
                if($('.'+$(this).attr('name')+'_textarea').val() == 'Client' || $('.'+$(this).attr('name')+'_textarea').val() == 'The Owner' || $('.'+$(this).attr('name')+'_textarea').val() == 'Client/GGM' || $('.'+$(this).attr('name')+'_textarea').val() == 'GGM' || $('.'+$(this).attr('name')+'_textarea').val() == 'Guardian' || $('.'+$(this).attr('name')+'_textarea').val() == 'N/A' ){
                    $(this).val($('.'+$(this).attr('name')+'_textarea').val());
                    $('.'+$(this).attr('name')+'_textarea').removeAttr('name');
                }else{
                    $('.'+$(this).attr('name')+'_textarea').removeClass('hidden').attr("disabled", false);
                    $(this).val('other');
                }


               // if($(this).val() == 'Client' && $(this).val() !== 'Client/GGM' && $(this).val() !== 'GGM' && $(this).val() !== 'Guardian' && $(this).val() !== 'N/A' && $(this).val() !== '0' )
               // {
               
            }
            /*
            if($(this).val() !== 'Client' && $(this).val() !== 'Client/GGM' && $(this).val() !== 'GGM' && $(this).val() !== 'Guardian' && $(this).val() !== 'N/A' && $(this).val() !== '0' )
            {
                $('.'+$(this).attr('name')+'_textarea').removeClass('hidden').attr("disabled", false);
            }else if($(this).val() == '0' ){
                $('.'+$(this).attr('name')+'_textarea').addClass('hidden').attr("disabled", true);
            }else{
                $(this).val($('.'+$(this).attr('name')+'_textarea').val());
                $('.'+$(this).attr('name')+'_textarea').empty();
            }*/


        });

    });

    
}();
